import {connect} from "react-redux";
import FilterModal, {MapDispatchToPropsType, MapStateToPropsType} from "../organisms/FilterModal";
import {IStateType} from "../../../../store/models/root.interface";
import {closeSideBar, getParams} from "../../../../store/sidebar";
import {Instances} from "../../../../constants";
import {
    changeFilters, makeSelectInProgress,
    makeSelectObjectsArray,
    removeObjects,
    requestObjects
} from "../../../../store/Objects";
import withImmutablePropsToJS from "with-immutable-props-to-js";
import {makeSelectObject} from "../../../../store/Object";


const MapStateToProps = (state:IStateType) => {
    const params = getParams(state);
    const selectLanguage = makeSelectObject(Instances.SttLanguages);
    const selectSpeechIds = makeSelectObjectsArray(Instances.SpeechIds);
    const speechIdSelectInProgress = makeSelectInProgress(Instances.SpeechIds);

    return {
        params,
        languageList:selectLanguage(state),
        speechIds:selectSpeechIds(state),
        speechIdInProgress:speechIdSelectInProgress(state)
    }
}

const MapDispatchToProps = {
    closeFilterModal : () => closeSideBar([removeObjects(Instances.SpeechIds)]),
    applyFilters: (filters:any) => changeFilters(Instances.SpeechLogs,filters),
    loadSpeechIds: (filters:any) => requestObjects(Instances.SpeechIds,filters),
}

export default connect<MapStateToPropsType,MapDispatchToPropsType,unknown,IStateType>(MapStateToProps,MapDispatchToProps)(withImmutablePropsToJS(FilterModal));